import { createContext } from 'react';

const weatherContext = createContext();

export default weatherContext;
